import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4aac02b4 = () => interopDefault(import('../pages/access-denied.vue' /* webpackChunkName: "pages/access-denied" */))
const _507e9eec = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _de6af6dc = () => interopDefault(import('../pages/glossary_page.vue' /* webpackChunkName: "pages/glossary_page" */))
const _3388c862 = () => interopDefault(import('../pages/help_page.vue' /* webpackChunkName: "pages/help_page" */))
const _d903760a = () => interopDefault(import('../pages/impersonate.vue' /* webpackChunkName: "pages/impersonate" */))
const _284214c9 = () => interopDefault(import('../pages/insights.vue' /* webpackChunkName: "pages/insights" */))
const _772f3b22 = () => interopDefault(import('../pages/jurisdiction.vue' /* webpackChunkName: "pages/jurisdiction" */))
const _0686aa0e = () => interopDefault(import('../pages/loggedout.vue' /* webpackChunkName: "pages/loggedout" */))
const _5da2356b = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _5609858a = () => interopDefault(import('../pages/not-found.vue' /* webpackChunkName: "pages/not-found" */))
const _3cabc425 = () => interopDefault(import('../pages/regulatory_analysis.vue' /* webpackChunkName: "pages/regulatory_analysis" */))
const _dcecd0de = () => interopDefault(import('../pages/regulatory_updates.vue' /* webpackChunkName: "pages/regulatory_updates" */))
const _d5a93788 = () => interopDefault(import('../pages/regulatory_updates_list.vue' /* webpackChunkName: "pages/regulatory_updates_list" */))
const _0a3d362e = () => interopDefault(import('../pages/reportbuilder.vue' /* webpackChunkName: "pages/reportbuilder" */))
const _048f8cb2 = () => interopDefault(import('../pages/reportbuilder-us.vue' /* webpackChunkName: "pages/reportbuilder-us" */))
const _7e320dc5 = () => interopDefault(import('../pages/requirement.vue' /* webpackChunkName: "pages/requirement" */))
const _647ebe89 = () => interopDefault(import('../pages/research.vue' /* webpackChunkName: "pages/research" */))
const _4a1d4127 = () => interopDefault(import('../pages/resources.vue' /* webpackChunkName: "pages/resources" */))
const _d1d2dcd4 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _13c3070e = () => interopDefault(import('../pages/tracker_topics.vue' /* webpackChunkName: "pages/tracker_topics" */))
const _5d579e20 = () => interopDefault(import('../pages/viq.vue' /* webpackChunkName: "pages/viq" */))
const _07092514 = () => interopDefault(import('../pages/world.vue' /* webpackChunkName: "pages/world" */))
const _3f43ae30 = () => interopDefault(import('../pages/profile/my-bookmarks.vue' /* webpackChunkName: "pages/profile/my-bookmarks" */))
const _060ad09c = () => interopDefault(import('../pages/profile/my-reports.vue' /* webpackChunkName: "pages/profile/my-reports" */))
const _6d6baa20 = () => interopDefault(import('../pages/profile/my-watchlist.vue' /* webpackChunkName: "pages/profile/my-watchlist" */))
const _c3d737a2 = () => interopDefault(import('../pages/profile/password.vue' /* webpackChunkName: "pages/profile/password" */))
const _18b676ed = () => interopDefault(import('../pages/profile/reset-password.vue' /* webpackChunkName: "pages/profile/reset-password" */))
const _d80adb58 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _880961ae = () => interopDefault(import('../pages/_analysisArticle.vue' /* webpackChunkName: "pages/_analysisArticle" */))
const _754a244c = () => interopDefault(import('../pages/_basicPage.vue' /* webpackChunkName: "pages/_basicPage" */))
const _af91578a = () => interopDefault(import('../pages/_guideArticle.vue' /* webpackChunkName: "pages/_guideArticle" */))
const _f3403a0e = () => interopDefault(import('../pages/_horizonPage.vue' /* webpackChunkName: "pages/_horizonPage" */))
const _3ce5d831 = () => interopDefault(import('../pages/_infocusPage.vue' /* webpackChunkName: "pages/_infocusPage" */))
const _13202bdf = () => interopDefault(import('../pages/_insightArticle.vue' /* webpackChunkName: "pages/_insightArticle" */))
const _b60dafde = () => interopDefault(import('../pages/_jurisdictionPage.vue' /* webpackChunkName: "pages/_jurisdictionPage" */))
const _5af05458 = () => interopDefault(import('../pages/_requirementArticle.vue' /* webpackChunkName: "pages/_requirementArticle" */))
const _7d310c3f = () => interopDefault(import('../pages/_trackerArticle.vue' /* webpackChunkName: "pages/_trackerArticle" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-denied",
    component: _4aac02b4,
    name: "access-denied"
  }, {
    path: "/error",
    component: _507e9eec,
    name: "error"
  }, {
    path: "/profile/glossary",
    component: _de6af6dc,
    name: "glossary_page"
  }, {
    path: "/profile/help",
    component: _3388c862,
    name: "help_page"
  }, {
    path: "/impersonate",
    component: _d903760a,
    name: "impersonate"
  }, {
    path: "/insights",
    component: _284214c9,
    name: "insights"
  }, {
    path: "/jurisdiction",
    component: _772f3b22,
    name: "jurisdiction"
  }, {
    path: "/loggedout",
    component: _0686aa0e,
    name: "loggedout"
  }, {
    path: "/login",
    component: _5da2356b,
    name: "login"
  }, {
    path: "/not-found",
    component: _5609858a,
    name: "not-found"
  }, {
    path: "/regulatory_analysis",
    component: _3cabc425,
    name: "regulatory_analysis"
  }, {
    path: "/regulatory_updates",
    component: _dcecd0de,
    name: "regulatory_updates"
  }, {
    path: "/regulatory_updates_list",
    component: _d5a93788,
    name: "regulatory_updates_list"
  }, {
    path: "/reportbuilder",
    component: _0a3d362e,
    name: "reportbuilder"
  }, {
    path: "/reportbuilder-us",
    component: _048f8cb2,
    name: "reportbuilder-us"
  }, {
    path: "/requirement",
    component: _7e320dc5,
    name: "requirement"
  }, {
    path: "/research",
    component: _647ebe89,
    name: "research"
  }, {
    path: "/resources",
    component: _4a1d4127,
    name: "resources"
  }, {
    path: "/search",
    component: _d1d2dcd4,
    name: "search"
  }, {
    path: "/trackers",
    component: _13c3070e,
    name: "tracker_topics"
  }, {
    path: "/viq",
    component: _5d579e20,
    name: "viq"
  }, {
    path: "/world",
    component: _07092514,
    name: "world"
  }, {
    path: "/profile/my-bookmarks",
    component: _3f43ae30,
    name: "profile-my-bookmarks"
  }, {
    path: "/profile/my-reports",
    component: _060ad09c,
    name: "profile-my-reports"
  }, {
    path: "/profile/my-watchlist",
    component: _6d6baa20,
    name: "profile-my-watchlist"
  }, {
    path: "/profile/password",
    component: _c3d737a2,
    name: "profile-password"
  }, {
    path: "/profile/reset-password",
    component: _18b676ed,
    name: "profile-reset-password"
  }, {
    path: "/",
    component: _d80adb58,
    name: "index"
  }, {
    path: "/article/:id/regulatory-analysis/:title",
    component: _880961ae,
    name: "analysisArticle"
  }, {
    path: "/:id",
    component: _754a244c,
    name: "basicPage"
  }, {
    path: "/guide/:id/:country",
    component: _af91578a,
    name: "guideArticle"
  }, {
    path: "/regulatory_update/:id/:title",
    component: _f3403a0e,
    name: "horizonPage"
  }, {
    path: "/in-focus/:id/:tagname",
    component: _3ce5d831,
    name: "infocusPage"
  }, {
    path: "/article/:id/insights/:title",
    component: _13202bdf,
    name: "insightArticle"
  }, {
    path: "/jurisdiction/:id/:country",
    component: _b60dafde,
    name: "jurisdictionPage"
  }, {
    path: "/requirement/:id",
    component: _5af05458,
    name: "requirementArticle"
  }, {
    path: "/tracker/:id/:name",
    component: _7d310c3f,
    name: "trackerArticle"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
